import axios, { AxiosResponse, AxiosError, AxiosRequestConfig } from 'axios'
import BizResponse from '@api/Response'

export class Response<T> implements AxiosResponse {
  config: AxiosRequestConfig
  data: T
  headers: any
  status: number
  statusText: string
}

export class ResponseError<T> implements AxiosError {
  config: AxiosRequestConfig
  isAxiosError: boolean
  message: string
  name: string
  response: Response<T>

  toJSON(): object {
    return {}
  }
}

const response: BizResponse<any> = new BizResponse<any>()
axios.interceptors.response.use(
  (data: AxiosResponse): any => {
    if (/\/gateway\/(practice|exam)/.test(data.config.url || '')) {
      response.status.message = ''
      response.status.errors = data.data.errors
      if (!data.data.status) {
        return response
      } else {
        response.status.code = 200
        response.data = data.data
        response['config'] = data.config
        return response
      }
    }
    return data
  },
  (error: AxiosError) => {
    if (/\/gateway\/exam/.test(error.config.url || '')) {
      response.status.httpCode = error.response?.status || 0
      Object.assign(response.status, error.response?.data)
      return response
    }
    return error
  }
)

export default axios
